// import { StatusCodes } from 'http-status-codes';

// const premiseURL = process.env.REACT_APP_SERVERURL;

export const apiPrefix = "api";
export const httpMethodType = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  delete: 'DELETE'
};

export class CasdoorService {
  constructor() {
    this.data = null;
    this.error = { code: null, message: null };
    this.defaultHeaders = { 'Content-Type': 'application/json; charset=utf-8' };
    this.httpMethodType = httpMethodType;
  }

  async sendRequest(url, config = {}) {
    // if (config.params) {
    //   const params = '?' + new URLSearchParams(config.params);
    //   url += params;
    // }

    // 使用 fetch 發送 HTTPS 請求
    const response = await fetch(url, {
      method: config.method ? config.method : this.httpMethodType.get,
      headers: config.headers ? config.headers : this.defaultHeaders,
      body: config.body ? config.body : null,
    });

    // if (response.status >= 500) { // 5xx server error
    //   this.error = { code: null, message: null };
    //   throw new Error(`Bad response from server: ${response.status}`);
    // }

    try {
      return await response.json();
    } catch (err) {
      return err;
    }

    // const data = await response.json();
    // if (!data.error) {
    //   this.data = data;
    //   this.error = { code: null, message: null };
    // } else {
    //   this.error.originCode = data.error.code;
    //   this.error.message = data.error.message;
    // }
    // return data;
  }

  // cleanDataAndError () {
  //   this.data = null;
  //   this.error = null;
  // }

  // hasError () {
  //   return !!this.error.code;
  // }
}